exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".l-lineup a {\n  text-decoration: none;\n}\n\n.lineup-model-wrap {\n  height: calc(118vw + 20px + 42px);\n}\n\n.kz-car-price {\n  text-align: center;\n  color: #545454;\n}\n", ""]);
